import { UseCustomAxios } from "../../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../../util/Utils";

export function UseFooterLists() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validateList(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا عنوان لیست را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validateListItems(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا عنوان آیتم را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetFooterList = (FooterId, callback) => {
    MyAxios.get(`Admin_HomePage/GetFooterList/${FooterId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SetFooterList = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_HomePage/SetFooterLists`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const RemoveFooterLists = (Id, callback) => {
    const data = new FormData();
    data.append("Id", Id);
    MyAxios.delete(`Admin_HomePage/RemoveFooterLists`, {
      data: data,
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("لینک با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const SetFooterListItems = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("icon", icon);
    }
    MyAxios.post(`Admin_HomePage/SetFooterListItems`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const RemoveFooterListItems = (Id, callback) => {
    const data = new FormData();
    data.append("Id", Id);
    MyAxios.delete(`Admin_HomePage/RemoveFooterListItems`, {
      data: data,
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("آیتم با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validateList,
    GetFooterList,
    SetFooterList,
    RemoveFooterLists,
    SetFooterListItems,
    RemoveFooterListItems,
    validateListItems,
  };
}
